import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from '../shared/models/api-response.model';

@Injectable({
  providedIn: 'root',
})
export class PagesService {
  constructor(private http: HttpClient) {}

  getVisitorsCountAccordingTime(fromDate, toDate) {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/visitors?from=' + fromDate + '&to=' + toDate
    );
  }
  getVisitorsCount() {
    return this.http.get<ApiResponseModel>('api/dashboard/cards/visitors');
  }
  getInquiriesCountAccordingTime(fromDate, toDate){
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/inquiries?from=' + fromDate + '&to=' + toDate
    );
  }
  getInquiriesCount(){
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/inquiries'
    );
  }
  getBookingsCountAccordingTime(fromDate, toDate){
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/bookings?from=' + fromDate + '&to=' + toDate
    );
  }
  getBookingsCount(){
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/bookings'
    );
  }
  getTravlersCountAccordingTime(fromDate, toDate){
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/travelers?from=' + fromDate + '&to=' + toDate
    );
  }
  getTravlersCount(){
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/travelers'
    );
  }
  getInquiresStatusCountAccordingTime(fromDate, toDate) {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/inquiries-status?from=' + fromDate + '&to=' + toDate
    );
  }
  getInquiresStatusCount() {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/inquiries-status'
    );
  }
  getVisitorsInquiresCountAccordingTime(fromDate, toDate) {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/cr/visitors-inquiries?from=' + fromDate + '&to=' + toDate
    );
  }
  getVisitorsInquiresCount(){
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/cr/visitors-inquiries'
    );
  }
  getBookingsInquiresCountAccordingTime(fromDate, toDate) {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/cr/bookings-inquiries?from=' + fromDate + '&to=' + toDate
    );
  }
  getBookingsInquiresCount() {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/cr/bookings-inquiries'
    );
  }
  getBookingsVistorsCountAccordingTime(fromDate, toDate) {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/cr/booking-visitor?from=' + fromDate + '&to=' + toDate
    );
  }
  getBookingsVistorsCount() {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/cr/booking-visitor'
    );
  }
  getTravelersLTVCountAccordingTime(fromDate, toDate) {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/travelers-ltv?from=' + fromDate + '&to=' + toDate
    );
  }
  getTravelersLTVCount() {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/travelers-ltv'
    );
  }
  getTopLandingCountAccordingTime(fromDate, toDate) {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/top-landing?from=' + fromDate + '&to=' + toDate
    );
  }
  getTopLandingCount() {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/top-landing'
    );
  }
  getTopExperiencesCountAccordingTime(fromDate, toDate) {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/top-experiences?from=' + fromDate + '&to=' + toDate
    );
  }
  getTopExperiencesCount() {
    return this.http.get<ApiResponseModel>(
      'api/dashboard/cards/top-experiences'
    );
  }
}
